import React from "react";
import BusinessIcon from "@mui/icons-material/Business";

import ImageCropUpload from "../generic/ImageCropUpload";

// Logo de la entidad. Igual que la foto del aspirante, es una capa fina sobre
// ImageCropUpload; lo propio de aquí es la proporción.
//
// 16:9 y no cuadrado porque un logo institucional casi siempre es apaisado
// (escudo + nombre en una línea), y forzarlo a un cuadrado obliga a recortar
// justo lo que lo identifica. Se pinta con `contain` por la misma razón.

export default function EntityLogoUpload({
  currentUrl,
  alt = "",
  disabled = false,
  onChange,
  onRemove,
}) {
  return (
    <ImageCropUpload
      currentUrl={currentUrl}
      alt={alt}
      disabled={disabled}
      aspect={16 / 9}
      shape="square"
      outputWidth={640}
      outputName="logo.jpg"
      label="Logo de la entidad"
      dialogTitle="Ajusta el logo"
      confirmLabel="Usar este logo"
      removeLabel="Quitar logo"
      changeAriaLabel="Cambiar el logo de la entidad"
      emptyIcon={<BusinessIcon sx={{ fontSize: "2.5rem" }} />}
      onChange={onChange}
      onRemove={onRemove}
    />
  );
}
